"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizationEntityType = exports.OptimizationResultsSortColumn = void 0;
var OptimizationResultsSortColumn;
(function (OptimizationResultsSortColumn) {
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["created_at"] = 0] = "created_at";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["stops_per_hour"] = 1] = "stops_per_hour";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["intersections"] = 2] = "intersections";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["total_route_duration"] = 3] = "total_route_duration";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["total_route_distance"] = 4] = "total_route_distance";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["total_routes"] = 5] = "total_routes";
    OptimizationResultsSortColumn[OptimizationResultsSortColumn["total_assigned_orders"] = 6] = "total_assigned_orders";
})(OptimizationResultsSortColumn || (exports.OptimizationResultsSortColumn = OptimizationResultsSortColumn = {}));
var OptimizationEntityType;
(function (OptimizationEntityType) {
    OptimizationEntityType["Task"] = "task";
    OptimizationEntityType["ActualBreak"] = "actual_break";
    OptimizationEntityType["RouteInfo"] = "route_info";
    OptimizationEntityType["Directions"] = "directions";
    OptimizationEntityType["UnassignedTask"] = "unassigned_task";
})(OptimizationEntityType || (exports.OptimizationEntityType = OptimizationEntityType = {}));
//# sourceMappingURL=optimization_result.js.map